'use strict'
/* eslint-env ga */
/* Browserify Requirements */
var vanillaMasker = require('vanilla-masker')
require('input-placeholder-polyfill')

/* Get elements */
var inputKroner = document.querySelector('input[name=kroner]')
var inputsParty = document.querySelectorAll('input[name=party]')

var outputKroner = document.querySelector('p[class=result]')
var outputPrice = document.querySelector('p[class=resultprice]')
var outputOverlay = document.querySelector('div[class=article-overlay]')
var outputOverlayDisclaimer = document.querySelector('p[class=disclaimer-text]')
var outputOverlayToggles = document.querySelectorAll('div[class=article-overlay-toggle]')
var outputArea = document.querySelector('div[class=resultarea]')

var initialInteraction = true
var moneyMask = {
  precision: 0,
  separator: ' ',
  delimiter: '.',
  suffixUnit: 'kr.',
  unit: '',
  zeroCents: false
}

/* Mask inputfields */
vanillaMasker(inputKroner).maskMoney({
  precision: 0,
  separator: ',',
  delimiter: '.',
  suffixUnit: '',
  unit: 'kr.',
  zeroCents: false
})

/* Set eventlistners */
inputKroner.addEventListener('focus', function (event) {
  outputArea.className = 'resultarea'
})
inputKroner.addEventListener('blur', startCalculator)
inputKroner.addEventListener('keyup', function (event) {
  event.preventDefault()
  if (event.keyCode === 13) {
    inputKroner.blur()
  }
})

for (var i = 0; i < inputsParty.length; i++) {
  inputsParty[i].addEventListener('change', startCalculator)
}

for (var u = 0; u < outputOverlayToggles.length; u++) {
  outputOverlayToggles[u].addEventListener('click', toggleOverlay)
}

inputKroner.addEventListener('focus', function () {
  this.value = ''
})

function startCalculator() {
  // Run calculator
  var result = calculateSavings()

  setResult(result['savings'], result['pricePerTaxpayer'])
  setDisclaimer(result)
  tracking()
}

/* Calculations go here */
function calculateSavings() {
  // Current tax rules
  var result = []

  result['numberOfTaxpayers'] = 4600000
  result['currentLimit'] = 467300
  result['currentPercentage'] = 0.15

  result['yearlyIncome'] = 12 * vanillaMasker.toNumber(inputKroner.value)
  result['yearlyIncomeNoAm'] = Math.round(result['yearlyIncome'] * 0.92)
  result['currentTopIncomeTax'] = Math.max(0, Math.round((result['yearlyIncomeNoAm'] - result['currentLimit']) * result['currentPercentage']))

  // Suggestion
  result['suggestedPercentage'] = 0.15 // Default
  result['suggestedLimit'] = 467300 // Default
  result['suggestedPrice'] = 46000000 // Default

  for (var i = 0, max = inputsParty.length; i < max; i++) {
    if (inputsParty[i].checked) {
      /* Get info from selected party */
      result['suggestedPercentage'] = inputsParty[i].getAttribute('data-percentage')
      result['partyName'] = inputsParty[i].getAttribute('data-name')
      result['suggestedPrice'] = inputsParty[i].getAttribute('data-price')
      break
    }
  }

  result['pricePerTaxpayer'] = Math.round(result['suggestedPrice'] / result['numberOfTaxpayers'])
  result['suggestedIncomeTax'] = Math.max(0, Math.round((result['yearlyIncomeNoAm'] - result['suggestedLimit']) * result['suggestedPercentage']))
  result['savings'] = result['currentTopIncomeTax'] - result['suggestedIncomeTax']

  return result
}

function getPositiveMoneyMask(kroner) {
  return vanillaMasker.toMoney(Math.max(0, kroner), moneyMask)
}

function getRounded(value) {
  return 100 * Math.round(value / 100.0)
}

function setResult(savings, price) {
  outputArea.className = 'resultarea active'
  outputKroner.innerHTML = getPositiveMoneyMask(getRounded(savings))
  outputPrice.innerHTML = 'Forslaget koster ca. ' + getPositiveMoneyMask(getRounded(price)) + ' per skatteyder'

  /* Show infobutton */
  for (var u = 0; u < outputOverlayToggles.length; u++) {
    outputOverlayToggles[u].style.display = 'block'
  }

  return true
}

function setDisclaimer(result) {
  var template = '<b>Beregning:</b><br><br>Beregningen er baseret på en årsindkomst på ' + getPositiveMoneyMask(result['yearlyIncomeNoAm']) + ' efter AM-bidrag. '
  if (result['currentTopIncomeTax'] > 0) {
    /* Toptaxes */
    template += 'I øjeblikket betaler du cirka <b>' + getPositiveMoneyMask(result['currentTopIncomeTax']) + '</b> i topskat om året.<br><br>'
    template += 'Med forslaget fra ' + result['partyName'] + ' sænkes topskatteprocenten til <b>' + (result['suggestedPercentage'] * 100) + '%</b>, hvilket sænker din topskat til ca. <b>' + getPositiveMoneyMask(result['suggestedIncomeTax']) + '</b>. Dette giver en besparelse på ca. <b>' + getPositiveMoneyMask(getRounded(result['savings'])) + '</b><br><br>'
  } else {
    /* No toptaxes */
    template += '<br><br><b>Din nuværende indkomst rammer ikke topskatgrænsen</b><br><br>'
  }

  template += 'Forslagets pris pr. skatteyder udregnes: <b>' + getPositiveMoneyMask(result['suggestedPrice']) + '</b> / <b>antal af skatteydere</b>'

  outputOverlayDisclaimer.innerHTML = template
}

function toggleOverlay() {
  outputOverlay.style.visibility = outputOverlay.style.visibility === 'visible' ? 'hidden' : 'visible'
}

function tracking() {
  /* Tracking */
  if (typeof ga !== 'undefined' && initialInteraction) {
    ga('send', { // eslint-disable-line no-undef
      hitType: 'event',
      eventCategory: 'Beregner - Topskat',
      eventAction: 'initial Interaction',
      eventLabel: 'embed'
    })
    initialInteraction = false
  }
}
